import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'ngx-activity-task-tour-snack-bar',
	imports: [
		TranslateModule,
		CommonModule
	],
	templateUrl: './activity-task-tour-snack-bar.component.html',
	styleUrl: './activity-task-tour-snack-bar.component.scss',
	standalone: true
})
export class ActivityTaskTourSnackBarComponent {
	private snackbarRef = inject(MatSnackBarRef<ActivityTaskTourSnackBarComponent>);

	public static open (snackBar: MatSnackBar) {
		return snackBar.openFromComponent(
			ActivityTaskTourSnackBarComponent,
			{
				panelClass: 'snack-bar-panel',
				horizontalPosition: 'end'
			}
		);
	}

	public close () {
		this.snackbarRef.dismiss();
	}
}
